var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOracleCloudInfrastructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67.8 50.6",
    style: {
      enableBackground: "new 0 0 67.8 50.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E50019;}\r\n\t.st1{font-family:'ArialMT';}\r\n\t.st2{font-size:6px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4747",
    transform: "translate(-1175 -1724.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oracle",
    className: "st0",
    d: "M1199.3,1747h2.5l-1.3-2.1l-2.4,3.9h-1.1l3-4.7c0.1-0.2,0.3-0.3,0.6-0.3c0.2,0,0.4,0.1,0.6,0.3 l3,4.7h-1.1l-0.5-0.9h-2.5L1199.3,1747z M1210.9,1747.9v-4h-0.9v4.4c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1h4.3l0.6-0.9 H1210.9z M1195.3,1747.2c0.9,0.1,1.7-0.6,1.8-1.5c0.1-0.9-0.6-1.7-1.5-1.8c-0.1,0-0.2,0-0.2,0h-4.1v4.9h0.9v-4h3.1 c0.4,0.1,0.8,0.5,0.7,0.9c0,0.4-0.3,0.7-0.7,0.7h-2.7l2.8,2.5h1.4l-1.9-1.6L1195.3,1747.2z M1185.3,1748.8c-1.4,0-2.5-1.1-2.5-2.5 c0-1.4,1.1-2.5,2.5-2.5c0,0,0,0,0,0h2.9c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5c0,0,0,0,0,0H1185.3z M1188.1,1747.9 c0.9,0,1.6-0.7,1.6-1.5c0-0.9-0.7-1.6-1.5-1.6c0,0-0.1,0-0.1,0h-2.8c-0.9,0-1.6,0.7-1.6,1.5c0,0.9,0.7,1.6,1.5,1.6c0,0,0.1,0,0.1,0 H1188.1z M1206.1,1748.8c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c0,0,0,0,0,0h3.4l-0.6,0.9h-2.8c-0.9,0-1.6,0.8-1.5,1.6 c0,0.8,0.7,1.5,1.5,1.5h3.4l-0.6,0.9L1206.1,1748.8z M1217.6,1747.9c-0.7,0-1.3-0.5-1.5-1.2h4l0.6-0.9h-4.6 c0.2-0.7,0.8-1.2,1.5-1.2h2.8l0.6-0.9h-3.4c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h2.9l0.6-0.9L1217.6,1747.9"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1182.5439 1755.1265)",
    className: "st1 st2"
  }, "Cloud Infrastructure"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracleCloudInfrastructure);
export default __webpack_public_path__ + "static/media/Oracle Cloud Infrastructure.06e6d98851935a10538790b365263e5a.svg";
export { ForwardRef as ReactComponent };